import(/* webpackMode: "eager" */ "/vercel/path0/app/donate/page.tsx");
